import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FormFieldComponent } from '../form-field.component.js';

export const passwordMinLength: number = 6;
export const passwordMaxLength: number = 50;

@Component({
    selector: 'ui-password-form-field',
    templateUrl: './password-form-field.component.html',
    styleUrls: ['../form-fields.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordFormFieldComponent extends FormFieldComponent<string> {
	public readonly showPassword = signal<boolean>(false);
	public readonly disableAutocomplete = input<boolean>(false);
	public readonly enablePasswordPreview = input<boolean>(true);

	protected readonly autocompleteValue = computed<string>(() => {
		if (this.disableAutocomplete()) {
			return 'new-password';
		}
		return '';
	});

	public readonly passwordMaxLength = passwordMaxLength;

	constructor() {
		super();
	}

	handleModelChange(value?: string): void {
		super.updateValue(value);
	}

	handleShowPasswordChange(value: boolean): void {
		this.showPassword.set(value);
	}

	protected getHint(value?: string): string | undefined {
		if (value) {
			if (value.length < passwordMinLength) {
				return `Min. length of password is ${passwordMinLength}`;
			}
			if (value.length > passwordMaxLength) {
				return `Max. length of password is ${passwordMaxLength}`;
			}
		}
		return undefined;
	}

	protected isValueValid(value?: string): boolean {
		if (value) {
			if (value.length >= passwordMinLength && value.length <= passwordMaxLength) {
				return true;
			}
		}
		return false;
	}
}
